import { conciergeApi } from "@/components/concierge/api";

const ENDPOINT = { returned_at: "returned", pressing_returned_at: "pressing-returned" };

export const toggleDepositStep = (deposit, field) => conciergeApi.put(`/deposits/${deposit.id}/${ENDPOINT[field]}`);
